import { useEffect, useState } from "react";
import { getBlogDetail, getBlogs } from "../services/api/api";
import { useParams } from "react-router-dom";
import Slider from "react-slick";

const TopBestWebHostingServices = () => {
  const settings = {
    slidesToShow: 3.5,
    slidesToScroll: 1,
    draggable: true,
    arrows: false,
    className: "blog_list",
    focusOnSelect: true,
    adaptiveHeight: false,
    prevArrow: (
      <div className="slickbtn slick-prev">
        <svg
          width="51"
          height="51"
          viewBox="0 0 51 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="25.5"
            cy="25.5"
            r="25.5"
            transform="rotate(180 25.5 25.5)"
            fill="url(#paint0_linear_17_4)"
          ></circle>
          <path
            d="M21.414 26L31 26L31 24L21.414 24L25.707 19.707L24.293 18.293L17.586 25L24.293 31.707L25.707 30.293L21.414 26Z"
            fill="white"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear_17_4"
              x1="-0.721698"
              y1="21.675"
              x2="51.0345"
              y2="22.22"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#09C2C1"></stop>
              <stop offset="1" stop-color="#1D85D8"></stop>
            </linearGradient>
          </defs>
        </svg>
      </div>
    ),
    nextArrow: (
      <div className="slickbtn slick-next">
        <svg
          width="51"
          height="51"
          viewBox="0 0 51 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="25.5"
            cy="25.5"
            r="25.5"
            fill="url(#paint0_linear_17_8)"
          ></circle>
          <path
            d="M29.586 25L20 25L20 27L29.586 27L25.293 31.293L26.707 32.707L33.414 26L26.707 19.293L25.293 20.707L29.586 25Z"
            fill="white"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear_17_8"
              x1="-0.721698"
              y1="21.675"
              x2="51.0345"
              y2="22.22"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#09C2C1"></stop>
              <stop offset="1" stop-color="#1D85D8"></stop>
            </linearGradient>
          </defs>
        </svg>
      </div>
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
    ],
  };

  const [blog, setBlog] = useState([]);
  let { blogId } = useParams();
  useEffect(() => {
    getBlogDetail(blogId).then((res) => {
      setBlog(res.data.result);
    });
  }, []);
  console.log(blog);
  return (
    <>
      <div
        className="blog_banner blog-dtl"
        style={{ backgroundImage: "url(./assets/images/new/blog-dtl.png)" }}
      >
        <div className="wrapper">
          <div className="blog-dtl-block">
            <a href="/blogs">
              <img src="/assets/images/new/arrow-blog.svg" alt="arrow" />
            </a>
            {/* this is banner is dynamic */}
            <img src="/assets/images/blogs/blog19.png" alt="blog" />
          </div>
        </div>
      </div>
      <div className="block-dtl">
        <div className="wrapper">
          <div className="social">
            <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/Facebook.svg"
                alt="facebook"
              />
            </a>
            <a href="https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/Linkedin.svg"
                alt="facebook"
              />
            </a>
            <a href="https://pinterest.com/pin/create/button/?url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img src="/assets/images/site/social/Social.svg" alt="facebook" />
            </a>
            <a href="https://x.com/intent/tweet?url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/twitter.png"
                alt="facebook"
              />
            </a>
            <a href="https://www.instagram.com/?url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/Instagram.svg"
                alt="facebook"
              />
            </a>
          </div>
          <div className="title">
            <div className="title-head">
              <a
                data-aos="zoom-out-up"
                href="javascript:void(0)"
                className="button-container-1 aos-init aos-animate"
              >
                <span className="mas">
               Web Hosting
                  {/* this is tag name (dynamic) */}
                </span>
                <span className="mask_btn">
                Web Hosting
                  {/* this is tag name (dynamic) */}
                </span>
              </a>

              <span>July 22, 2025</span>
            </div>
            {/* all this content is dynamic  */}
            <div
            // dangerouslySetInnerHTML={{ __html: blog.page_content }}
            >
              <h2>
              Top 10 Best Web Hosting Services in 2025
              </h2>
              
              
              <h4>1. Cloudways (Best All-Round Managed Cloud Hosting)</h4><br></br>
                <ul>
                    <li>Built on AWS, Google Cloud, DigitalOcean & more</li>
                    <li>Managed security, auto-healing servers</li>
                    <li>Great for agencies, developers & growing businesses</li>
                </ul>
              
              <h4>2. Hostinger (Best Value for Money)</h4><br></br>
                <ul>
                <li>Ultra-fast servers (NVMe, LiteSpeed)</li>
                <li>Affordable plans starting under $2/month</li>
                <li>AI-powered tools, website builder included</li>
                </ul>
                
                <h4>3. SiteGround (Best for Business & WordPress)</h4><br></br>
                <ul>
                <li>Google Cloud infrastructure</li>
                <li>Stellar customer support</li>
                <li>Easy staging, caching, Git integration</li>
                </ul>
                
                <h4>4. Kinsta (Premium Managed WordPress Hosting)</h4><br></br>
             <ul>
<li>Powered by Google Cloud C2 Machines</li>
<li>Built-in CDN, caching, malware scanning</li>
<li>Beautiful UI and analytics dashboard</li>
</ul>

<h4>5. Bluehost (Beginner-Friendly & Official WordPress Partner)</h4><br></br>
<ul>
<li>Free domain, SSL, and email</li>
<li>Built-in site builder</li>
<li>Ideal for first-time users</li>
</ul>

<h4>6. WP Engine (Enterprise WordPress Hosting)</h4><br></br>
<ul>
<li>Advanced DevOps tools</li>
<li>Staging + version control</li>
<li>Enterprise-grade security</li>
</ul>

<h4>7. DigitalOcean App Platform (Developer-Focused PaaS)</h4><br></br>
<ul>
<li>Deploy apps in one click (Node, Python, PHP, etc.)</li>
<li>GitHub integration</li>
<li>Simple autoscaling</li>
</ul>

<h4>8. A2 Hosting (Best for Speed & Turbo Plans)</h4><br></br>
<ul>
<li>Turbo servers (up to 20x faster)</li>
<li>Developer-friendly: SSH, staging, Git</li>
<li>24/7 Guru Crew Support</li>
</ul>

<h4>9. GreenGeeks (Best Eco-Friendly Hosting)</h4><br></br>
<ul>
<li>300% green energy match</li>
<li>Free CDN, SSL, and backups</li>
<li>Fast support</li>
</ul>

<h4>10. IONOS by 1&1 (Best for European Businesses)</h4><br></br>
<ul>
<li>Cheap plans with strong features</li>
<li>European data centers (GDPR-compliant)</li>
<li>Good support & scalability</li>
</ul>

<h4>Final Thoughts</h4><br></br>
<p>Choosing the right hosting provider in 2025 depends on your goals, traffic, tech skills, and budget. Cloud-based, secure, and performance-optimized hosting is now the norm. Always check:</p>
<ul>
<li>Server locations</li>
<li>Support quality</li>
<li>Uptime guarantee</li>
<li>Tools & scalability options</li>
</ul>
            </div>
          </div>
        </div>
      </div>
      <div className="topics-sec">
        <div className="wrapper">
          <div className="topics-head">
            <h3>related topics</h3>
            <a
              data-aos="zoom-out-up"
              href="/blogs"
              className="button-container-1 aos-init aos-animate"
            >
              <span className="mas">View More</span>
              <span className="mask_btn">View More</span>
            </a>
          </div>
          <div className="topics-block">
            <Slider {...settings}>
              {/* href id is dynamic like blog/item.id */}
              <a href={`/best-web-development-company`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="./assets/images/blogs/blog1.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span> Web Development</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        Best Web Development Company: Transforming Your Digital
                        Presence Globally
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <a href={`/custom-mobile-app-development-services`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="./assets/images/blogs/blog16.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span>App Development</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        Elevate Your Business with Custom Mobile App Development
                        Services
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <a href={`/leading-php-company`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="./assets/images/blogs/blog15.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span> Web Development</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        Leading PHP Development Company in India: Unlocking Your
                        Digital Potential
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <a href={`/best-UI-UX-design`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="/assets/images/blogs/blog9.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span>ui & ux</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        We Provide the Best UI/UX Design Solutions for
                        Exceptional User Experiences{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopBestWebHostingServices;
